import VendorContainer from '../../containers/Vendor'
import React from 'react'

function Vendor(props) {
  return (
    <div>
        <VendorContainer {...props}/>
    </div>
  )
}

export default Vendor